import { Action } from '@ngrx/store';
import { SearchRequest } from '../../shared/models/search-request.model';
import { DocumentWithId, DocumentWithRev } from '../../../../shared/services/db/models/document-with-type';

export const SAVE_SEARCH_REQUEST = '[XENA] SAVE_SEARCH_REQUEST';
export const SAVE_SEARCH_REQUEST_SUCCESS = '[XENA] SAVE_SEARCH_REQUEST_SUCCESS';
export const SAVE_SEARCH_REQUEST_ERROR = '[XENA] SAVE_SEARCH_REQUEST_ERROR';

export const LOAD_SEARCH_REQUEST = '[XENA] LOAD_SEARCH_REQUEST';
export const LOAD_SEARCH_REQUEST_SUCCESS = '[XENA] LOAD_SEARCH_REQUEST_SUCCESS';
export const LOAD_SEARCH_REQUEST_ERROR = '[XENA] LOAD_SEARCH_REQUEST_ERROR';

export const RENAME_SEARCH_REQUEST = '[XENA] RENAME_SEARCH_REQUEST';
export const RENAME_SEARCH_REQUEST_SUCCESS = '[XENA] RENAME_SEARCH_REQUEST_SUCCESS';
export const RENAME_SEARCH_REQUEST_ERROR = '[XENA] RENAME_SEARCH_REQUEST_ERROR';

export const DELETE_SEARCH_REQUEST = '[XENA] DELETE_SEARCH_REQUEST';
export const DELETE_SEARCH_REQUEST_SUCCESS = '[XENA] DELETE_SEARCH_REQUEST_SUCCESS';
export const DELETE_SEARCH_REQUEST_ERROR = '[XENA] DELETE_SEARCH_REQUEST_ERROR';

export class SaveSearchRequest implements Action {
	readonly type = SAVE_SEARCH_REQUEST;

	constructor(public payload: SearchRequest) {}
}

export class SaveSearchRequestSuccess implements Action {
	readonly type = SAVE_SEARCH_REQUEST_SUCCESS;

	constructor(public payload: SearchRequest) {}
}

export class SaveSearchRequestError implements Action {
	readonly type = SAVE_SEARCH_REQUEST_ERROR;
}

export class LoadSearchRequest implements Action {
	readonly type = LOAD_SEARCH_REQUEST;
}

export class LoadSearchRequestSuccess implements Action {
	readonly type = LOAD_SEARCH_REQUEST_SUCCESS;

	constructor(public payload: SearchRequest[]) {}
}

export class LoadSearchRequestError implements Action {
	readonly type = LOAD_SEARCH_REQUEST_ERROR;
}

export class RenameSearchRequest implements Action {
	readonly type = RENAME_SEARCH_REQUEST;

	constructor(public payload: {searchRequestId, newName}) {};
}

export class RenameSearchRequestSuccess implements Action {
	readonly type = RENAME_SEARCH_REQUEST_SUCCESS;

	constructor(public payload: SearchRequest) {};
}

export class RenameSearchRequestError implements Action {
	readonly type = RENAME_SEARCH_REQUEST_ERROR;
}

export class DeleteSearchRequest implements Action {
	readonly type = DELETE_SEARCH_REQUEST;

	constructor(public payload: string) {};
}

export class DeleteSearchRequestSuccess implements Action {
	readonly type = DELETE_SEARCH_REQUEST_SUCCESS;

	constructor(public payload: (DocumentWithId & DocumentWithRev)) {};
}

export class DeleteSearchRequestError implements Action {
	readonly type = DELETE_SEARCH_REQUEST_ERROR;
}

export type All
	= SaveSearchRequest
	| SaveSearchRequestSuccess
	| SaveSearchRequestError
	| LoadSearchRequest
	| LoadSearchRequestSuccess
	| LoadSearchRequestError
	| RenameSearchRequest
	| RenameSearchRequestSuccess
	| RenameSearchRequestError
	| DeleteSearchRequest
	| DeleteSearchRequestSuccess
	| DeleteSearchRequestError;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/search-request.ts